exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inbox-filter{height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.inbox-filter .custom-checkbox{padding-left:2rem}.inbox-filter .custom-control-alternative .custom-control-label:before{border-radius:4px;left:-2rem}.inbox-filter .custom-control-alternative .custom-control-label:after{left:-2rem}.inbox-filter .custom-control-label{color:inherit;text-transform:inherit}.inbox-filter .leads-container{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);

// exports
